import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'CustomPage',
    column_type: 'id',
    label_key_path: 'customPage.id',
  },
  created_at: {
    model_name: 'CustomPage',
    column_type: 'datetime',
    label_key_path: 'customPage.createdAt',
  },
  updated_at: {
    model_name: 'CustomPage',
    column_type: 'datetime',
    label_key_path: 'customPage.updatedAt',
  },
  title: {
    model_name: 'CustomPage',
    column_type: 'string',
    label_key_path: 'customPage.title',
  },
  slug: {
    model_name: 'CustomPage',
    column_type: 'string',
    label_key_path: 'customPage.slug',
  },
  default: {
    model_name: 'CustomPage',
    column_type: 'boolean',
    label_key_path: 'customPage.default',
  },
  mini_program_path: {
    model_name: 'CustomPage',
    column_type: 'string',
    label_key_path: 'customPage.miniProgramPath',
  },
  formal_custom_page_id: {
    model_name: 'CustomPage',
    column_type: 'string',
    label_key_path: 'customPage.formalCustomPageId',
  },
  can_rollback_data: {
    model_name: 'CustomPage',
    column_type: 'string',
    label_key_path: 'customPage.canRollbackData',
  },
  configs: {
    model_name: 'CustomPage',
    column_type: 'string',
    label_key_path: 'customPage.configs',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
